import { Breakpoints } from '../breakpoints/breakpoints';
import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        root: '.carousel-hero',
        slides: '.carousel-hero__slides',
        slide: '.carousel-hero__slide',
        next: '.carousel-hero__next',
        prev: '.carousel-hero__prev',
        nextSlide: '.carousel-hero__slide--next',
        prevSlide: '.carousel-hero__slide--prev',
        dots: '.carousel-hero__dots',
        dot: '.carousel-hero__dot',
        greyDot: '.carousel-hero__dot-grey',
        activeDot: '.carousel-hero__dot--active',
        playPauseBtn: '.carousel-hero__play-pause-btn',
        playPauseBtnIcon: '.carousel-hero__play-pause-btn-icon',
        playPauseBtnImageVideoTile: '.image-video-tile__play-pause-btn-icon',

    },
    classNames: {
        tripple: 'large-image-video-tile__tripple',
        header: 'carousel-hero--header',
        slideDotActive: 'carousel-hero__dot--active',
        slideDotsPaused: 'carousel-hero__dots--paused',
        btnPlaying: 'carousel-hero__play-pause-btn--playing',
        slideActive: 'carousel-hero__slide--active',
        slidePrev: 'carousel-hero__slide--prev',
        slideNext: 'carousel-hero__slide--next',
        playIcon: 'icon-TickCirclePlay3',
        pauseIcon: 'icon-TickCirclePause3',
        imageVideoTilePlayIcon: 'image-video-tile__play-pause-btn-icon--play',
        imageVideoTilePauseIcon: 'image-video-tile__play-pause-btn-icon--pause',
    },
    dataAttributes: {
        slides: 'slides',
        slide: 'slide',
        dotnumber: 'dotnumber',
        imageLength: 'image-length',
        autoplay: 'autoplay'
    },
    sliderConfig: {
        arrows: false,
        dots: false,
        infinite: true,
        speed: 750,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        autoplay: true,
        autoplaySpeed: 4000,
        responsive: [
            {
                breakpoint: Breakpoints.BREAKPOINTS.SM,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '8.33%',
                },
            },
        ],
    },
    sliderConfigHero: {
        arrows: false,
        dots: false,
        infinite: true,
        speed: 750,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        autoplay: false,
        autoplaySpeed: 4000,
        responsive: [
            {
                breakpoint: Breakpoints.BREAKPOINTS.SM,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                },
            },
        ],
    },
    sliderConfigProducts: {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 750,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        autoplay: false,
        autoplaySpeed: 2500,
        centerPadding: '8.33%',
        responsive: [
            {
                breakpoint: Breakpoints.BREAKPOINTS.LG,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '8.33%',
                },
                
            }
        ],
    },
};

class CarouselHero {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = null;
        this._isPaused = false;
        this._slides = [];
        this._currentSlide = 0;
        this._isInitialized = false;
        this._nextSlides = [];
        this._prevSlides = [];
        this._doneFix = false;
        this._imageDuration = 5000;
        this._currentTime = 0;
        this._timer = null;
        this._isPlaying = false;
        this._isVideoPlaying = false;
    }

    async init() {
    
        const _this = this;
        this._elements = this._getDomElements();

        if (this._$rootElement.hasClass(config.classNames.header)) {
            this._elements.$slides.slick(config.sliderConfigHero);
        } else if (this._$rootElement.hasClass('carousel-hero--products')) {
            this._elements.$slides.slick(config.sliderConfigProducts);
        } else {
            this._elements.$slides.slick(config.sliderConfig);
        }
      
        if(this._elements.$slide.find('.video-js')) {
            const videoElmenent = this._elements.$slide.find('.video-js')
            $(videoElmenent).closest('.image-video-tile__video-wrapper').siblings('.image-video-tile__fullscreen-icon').css('display', 'block')
        }
        
        for (const element of this._elements.$slides) {          
            const slideNoAutoplay = $(element).find('.image-video-tile__video-wrapper[data-autoplay="false"]')
       
            if(slideNoAutoplay.find('.video-js').length > 0){
                const siblingTextContainer = slideNoAutoplay.siblings('.image-video-tile__textblock-container');
              
                siblingTextContainer.find('.image-video-tile__play-pause-btn').css("display", 'flex');
                siblingTextContainer.find('.image-video-tile__play-pause-btn-icon').css("display", 'flex');
                siblingTextContainer.find('.image-video-tile__play-pause-btn-icon').addClass(config.classNames.imageVideoTilePlayIcon);
            }
        }
        
        if(this._$rootElement) {
            // read data attribute
            if(this._$rootElement.data(config.dataAttributes.imageLength)) {
                this._imageDuration = this._$rootElement.data(config.dataAttributes.imageLength) || 5000;
            }
            
            _this._updateDots(0);
            _this._updateClasses();
            _this._onSlideChange();

            this._elements.$slides.on('beforeChange', async (event, slick, currentSlide, nextSlide) => {
                clearInterval(_this._timer);
                _this._isPlaying = true;
                _this._currentSlide = nextSlide;
                _this._updateDots(nextSlide);
                _this._updateClasses();
                _this._onSlideChange();
                
            });

            $('.image-video-tile__play-pause-btn').on('click', async () => {
                clearInterval(this._timer);
                this._isPlaying = true;
                if(this._isVideoPlaying){
                    this._pauseAllVideos();
                    this._isVideoPlaying = false;
                    this._onSlideChange();
                }else {
                    this._isVideoPlaying = true;
                    this._onSlideChange();
                }
              
            });

       
            this._elements.$next.on('click', () => {
                this._pauseAllVideos();
                this._isPlaying = false;
                this._elements.$slides.slick('slickNext');
            });
    
            this._elements.$prev.on('click', () => {
                this._pauseAllVideos();
                this._isPlaying = false;

                if (this._currentSlide === 0) {
                    this._goToSlide(this._elements.$slide.length - 1);
                } else {
                    this._elements.$slides.slick('slickPrev');
                }
            });

            this._elements.$greyDot.on('click', (e) => {
                this._isPlaying = false;
                const $currentTarget = $(e.currentTarget);
                const dotnumber = $currentTarget[0].lastElementChild.getAttribute('data-dotnumber');
                this._goToSlide(dotnumber);
            });


        } else {
          
            this._addEventListeners();
            this._updateDots(0);
            this._updateClasses();
        }

        this._isInitialized = true;
    }

    _getDomElements() {
        return {
            $slides: this._$rootElement.find(config.selectors.slides),
            $slide: this._$rootElement.find(config.selectors.slide),
            $next: this._$rootElement.find(config.selectors.next),
            $prev: this._$rootElement.find(config.selectors.prev),
            $dots: this._$rootElement.find(config.selectors.dots),
            $dot: this._$rootElement.find(config.selectors.dot),
            $greyDot: this._$rootElement.find(config.selectors.greyDot),
            $playPauseBtn: this._$rootElement.find(config.selectors.playPauseBtn),
            $playPauseBtnIcon: this._$rootElement.find(config.selectors.playPauseBtnIcon),
        };
    }

    _addEventListeners() {
        const _this = this;

        this._elements.$playPauseBtn.on('click', () => {
            this._isPaused = !this._isPaused;
            const $btn = this._$rootElement.find(config.selectors.playPauseBtn);
            if (this._isPaused) {
                this._elements.$slides.slick('slickPause');
                $btn.removeClass(config.classNames.btnPlaying);
                this._elements.$playPauseBtnIcon.removeClass(config.classNames.pauseIcon);
                this._elements.$playPauseBtnIcon.addClass(config.classNames.playIcon);
                this._elements.$dots.addClass(config.classNames.slideDotsPaused);
            } else {
                this._elements.$slides.slick('slickPlay');
                $btn.addClass(config.classNames.btnPlaying);
                this._elements.$playPauseBtnIcon.removeClass(config.classNames.playIcon);
                this._elements.$playPauseBtnIcon.addClass(config.classNames.pauseIcon);
                this._elements.$dots.removeClass(config.classNames.slideDotsPaused);
            }
        });

        this._elements.$greyDot.on('click', (e) => {
            const $currentTarget = $(e.currentTarget);
            const dotnumber = $currentTarget[0].lastElementChild.getAttribute('data-dotnumber');
            this._goToSlide(dotnumber);
        });

        this._elements.$next.on('click', () => {
            const videoSettings = this._$rootElement.find('.slick-current').find('.video-js')[0];
            if (videoSettings) {
                videoSettings.player.pause();
                $(config.selectors.playPauseBtnImageVideoTile).removeClass(config.classNames.pauseImageVideoTile)
                $(config.selectors.playPauseBtnImageVideoTile).addClass(config.classNames.playImageVideoTile)
             
            }
            this._elements.$slides.slick('slickNext');
        });

        this._elements.$prev.on('click', () => {
            const videoSettings = this._$rootElement.find('.slick-current').find('.video-js')[0];
            if (videoSettings) {
                videoSettings.player.pause();
                $(config.selectors.playPauseBtnImageVideoTile).removeClass(config.classNames.pauseImageVideoTile)
                $(config.selectors.playPauseBtnImageVideoTile).addClass(config.classNames.playImageVideoTile)
            }
            if (this._currentSlide === 0) {
                this._goToSlide(2);
            } else {
                this._elements.$slides.slick('slickPrev');
            }
        });

        this._$rootElement.find(config.selectors.slide).on('click', (x) => {
            const $slide = x.currentTarget.attributes.class.value;
            if ($slide.includes(config.classNames.slideNext)) {
                this._elements.$slides.slick('slickNext');
            } else if ($slide.includes(config.classNames.slidePrev)) {
                if (this._currentSlide === 0) {
                    this._goToSlide(2);
                } else {
                    this._elements.$slides.slick('slickPrev');
                }
            }
        });

        this._$rootElement.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
            _this._currentSlide = nextSlide;
            _this._updateDots(nextSlide);
            _this._updateClasses();
        });

        this._$rootElement.on('breakpoint', (event, slick, currentSlide, nextSlide) => {
            _this._updateClasses();
        });
    }

    _pauseAllVideos() {
        const $currentSlide = $(this._elements.$slide[this._currentSlide]);
        this._$rootElement.find('.video-js').each((i, video) => {
            if(video && video.player) {
                video.player.pause();
                $currentSlide.find('.image-video-tile__play-pause-btn-icon').addClass(config.classNames.imageVideoTilePlayIcon);
                $currentSlide.find('.image-video-tile__play-pause-btn-icon').removeClass(config.classNames.imageVideoTilePauseIcon);
            }
        });
    }

    _onVideoTimerTick() {
        
        const $currentSlide = $(this._elements.$slide[this._currentSlide]);
        const $video = $currentSlide.find('.video-js');
        const videoDuration = $video[0].player.duration() * 1000;
        const currentTime = $video[0].player.currentTime() * 1000;

        if(currentTime >= videoDuration) {
            clearInterval(this._timer);
            this._isPlaying = false;
            this._isVideoPlaying = false;
            $currentSlide.find('.image-video-tile__play-pause-btn-icon').addClass(config.classNames.imageVideoTilePlayIcon);
            $currentSlide.find('.image-video-tile__play-pause-btn-icon').removeClass(config.classNames.imageVideoTilePauseIcon);
            this._elements.$slides.slick('slickNext');
          
            return;
        }

        if(this._isPlaying) {
            this._currentTime = currentTime;
        }
    }

    _onImageTimerTick() {
        if((this._currentTime * 1000) >= this._imageDuration) {
            clearInterval(this._timer);
            this._isPlaying = false;
            this._elements.$slides.slick('slickNext');
            

            return;
        }
    
        if(this._isPlaying) {
            this._currentTime += 1;
        }
    }

    async _onSlideChange() {
        const _this = this;
        const $currentSlide = $(this._elements.$slide[this._currentSlide]);
        const $video = $currentSlide.find('.video-js');
        const isVideo = !($video.length === 0);
        this._pauseAllVideos();
      
        if(isVideo ) {
            if( $currentSlide.find('.image-video-tile__video-wrapper').data(config.dataAttributes.autoplay)) {
                $currentSlide.find('.image-video-tile__play-pause-btn-icon').removeClass(config.classNames.imageVideoTilePlayIcon);
                $currentSlide.find('.image-video-tile__play-pause-btn-icon').addClass(config.classNames.imageVideoTilePauseIcon);
                try {
                    $video.find('video')[0].removeAttribute("loop");
                    $video[0].removeAttribute("loop");
                    $video[0].player.loop(false);
                    $video[0].player.muted(true);
                    
                    const promise = await $video[0].player.play();
    
                    $currentSlide.find('.image-video-tile__image-wrapper').hide();
                    $currentSlide.find('.image-video-tile__video-wrapper').show();
                    $currentSlide.find('.image-video-tile__play-pause-btn-icon').removeClass(config.classNames.imageVideoTilePlayIcon);
                    $currentSlide.find('.image-video-tile__play-pause-btn-icon').addClass(config.classNames.imageVideoTilePauseIcon);
    
                    this._isPlaying = true;
    
                    this._timer = setInterval(async function () {
                        _this._onVideoTimerTick();
                    }, 10);
                } catch (error) {
                    // console.log('error', error);
                    this._currentTime = 0;
                    this._isPlaying = true;
                    this._timer = setInterval(async function () {
                        _this._onImageTimerTick();
                    }, 1000);
                }
            }else {
                clearInterval(this._timer);
                if(!this._isVideoPlaying){
                    this._currentTime = 0;
                      this._isPlaying = true;
                    this._timer = setInterval(async function () {
                        _this._onImageTimerTick();
                    }, 1000);
                }else {
                    $currentSlide.find('.image-video-tile__play-pause-btn-icon').removeClass(config.classNames.imageVideoTilePlayIcon);
                    $currentSlide.find('.image-video-tile__play-pause-btn-icon').addClass(config.classNames.imageVideoTilePauseIcon);
                    try {
                        $video.find('video')[0].removeAttribute("loop");
                        $video[0].removeAttribute("loop");
                        $video[0].player.loop(false);
                        $video[0].player.muted(false);
                        
                        const promise = await $video[0].player.play();
        
                        $currentSlide.find('.image-video-tile__image-wrapper').hide();
                        $currentSlide.find('.image-video-tile__video-wrapper').show();
                        $currentSlide.find('.image-video-tile__play-pause-btn-icon').removeClass(config.classNames.imageVideoTilePlayIcon);
                        $currentSlide.find('.image-video-tile__play-pause-btn-icon').addClass(config.classNames.imageVideoTilePauseIcon);
                        clearInterval(this._timer);
                        this._isPlaying = true;
                        this._isVideoPlaying=true;
                        this._timer = setInterval(async function () {
                            _this._onVideoTimerTick();
                        }, 10);
                    } catch (error) {
                      
                        this._currentTime = 0;
                        this._isPlaying = true;
                        this._timer = setInterval(async function () {
                            _this._onImageTimerTick();
                        }, 1000);
                    }
                }
            }

        } else {
            this._currentTime = 0;
            this._isPlaying = true;
            this._timer = setInterval(async function () {
                _this._onImageTimerTick();
            }, 1000);
        }
    }


    _updateClasses() {
        let $currentEl = null;
        this._prevSlides = [];
        this._nextSlides = [];
        

        this._$rootElement.find(config.selectors.slide).each((i, el) => {
            const $el = $(el);
            $el.removeClass(config.classNames.slidePrev);
            $el.removeClass(config.classNames.slideNext);
            $el.removeClass(config.classNames.slideActive);

            if (this._currentSlide === i) {
                $currentEl = $el;
            }

            if (this._isInitialized && this._currentSlide === 0 && $el.data('slick-index') === 3) {
                $el.addClass(config.classNames.slideActive);
                // this._$rootElement.find('[data-slick-index=1]').addClass(config.classNames.slidePrev);
                this._$rootElement.find('[data-slick-index=2]').addClass(config.classNames.slidePrev);
                this._$rootElement.find('[data-slick-index=4]').addClass(config.classNames.slidePrev);
                return;
            }

            if ($el.data('slick-index') < this._currentSlide) {
                if(!$el.hasClass(config.selectors.nextSlide)) {
                    $el.addClass(config.classNames.slidePrev);
                    this._prevSlides.push($el);
                }
            } else if (this._currentSlide === $el.data('slick-index')) {
                $el.addClass(config.classNames.slideActive);
            } else if ($el.data('slick-index') > this._currentSlide) {
                $el.addClass(config.classNames.slideNext);
                this._nextSlides.push($el);
            }
        });

        this._doneFix = true;
    }

    _updateDots(index) {
        const $items = this._$rootElement.find(config.selectors.dot);
        $items.removeClass(config.classNames.slideDotActive);
        $($items[index % $items.length]).addClass(config.classNames.slideDotActive);
    }

    _goToSlide(dotnumber) {
        this._currentSlide = dotnumber;
        this._elements.$slides.slick('slickGoTo', dotnumber);
    }
}

moduleRegistry.registerModule('CarouselHero', CarouselHero);
moduleRegistry.autoApplyModule('CarouselHero', config.selectors.root);
